
































































































































































import { Component, Vue } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import LaporanSvc, {
  KategoriReaksi,
  ReaksiTransfusiRow,
  ReaksiTransfusiResponse
} from "@/services/LaporanReaksiTransfusi";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import moment from "moment";

const KATEGORI_LABEL: Record<KategoriReaksi, string> = {
  demam: "Demam",
  alergi: "Alergi",
  hemolisis: "Hemolisis",
  lainnya: "Lainnya"
};

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class LaporanReaksiTransfusiPage extends Vue {
  filter: {
    tgl_start: string;
    tgl_end: string;
    unit_id: string | null;
    kategori: KategoriReaksi | null;
    term: string | null;
  } = {
    tgl_start: moment().startOf("month").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    unit_id: null,
    kategori: null,
    term: null
  };

  rows: ReaksiTransfusiRow[] = [];
  summary: ReaksiTransfusiResponse["summary"] | null = null;
  loading = false;
  downloading = false;
  printingId: number | null = null;

  readonly kategoriLabel = KATEGORI_LABEL;
  readonly kategoriItems = (Object.keys(KATEGORI_LABEL) as KategoriReaksi[]).map(k => ({
    value: k,
    text: KATEGORI_LABEL[k]
  }));

  readonly headers = [
    { text: "Tgl Kejadian", value: "tanggal_kejadian_label", width: "120px" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Ruang", value: "unit_nama" },
    { text: "Gol. Darah", value: "darah", sortable: false, width: "110px" },
    { text: "Kantong", value: "kantong", sortable: false },
    { text: "Crossmatch", value: "hasil_crossmatch" },
    { text: "Reaksi", value: "reaksi_teks", sortable: false },
    { text: "Laporan", value: "laporan_lengkap", width: "110px" },
    { text: "", value: "aksi", sortable: false, width: "50px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res = await LaporanSvc.list(this.filter);
      this.rows = res.rows || [];
      this.summary = res.summary;
    } catch {
      this.rows = [];
      this.summary = null;
    } finally {
      this.loading = false;
    }
  }

  async unduh() {
    this.downloading = true;
    try {
      await LaporanSvc.downloadExcel(this.filter);
    } catch {
      return;
    } finally {
      this.downloading = false;
    }
  }

  async cetak(item: ReaksiTransfusiRow) {
    this.printingId = item.id;
    try {
      await MonitoringTransfusiSvc.openLaporanReaksiPdf(item.id);
    } catch {
      return;
    } finally {
      this.printingId = null;
    }
  }
}
